"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var StreakCounterCountIcon_1 = __importDefault(require("./StreakCounterCountIcon"));
function getDayLabel(index, length) {
    var day = dayjs_1.default()
        .add(index - length + 1, 'day')
        .toDate()
        .getDay();
    return ['S', 'M', 'T', 'W', 'T', 'F', 'S'][day];
}
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            overflow: 'visible',
        },
        paper: {
            width: 300 + theme.spacing(4),
            boxSizing: 'border-box',
            position: 'relative',
            padding: theme.spacing(3, 2, 3, 2),
            backgroundColor: '#FAFAFA',
            zIndex: 'auto',
            boxShadow: '0px 3px 5px -1px rgba(0, 0, 0, 0.1),0px 5px 8px 0px rgba(0, 0, 0, 0.07),0px 1px 14px 0px rgba(0, 0, 0, 0.06)',
            overflow: 'visible',
            marginTop: 11,
        },
        arrow: {
            position: 'absolute',
            top: -32,
            right: 14,
            width: 32,
            height: 32,
            overflow: 'hidden',
            boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
            '&::after': {
                content: '""',
                position: 'absolute',
                borderTopLeftRadius: 2,
                width: 16,
                height: 16,
                backgroundColor: '#FAFAFA',
                transform: 'rotate(45deg)',
                top: 24,
                left: 8,
                boxShadow: '-1px -1px 10px -5px rgba(0, 0, 0, 0.5)',
            },
        },
        topRow: {
            display: 'flex',
            alignItems: 'center',
        },
        currentStreak: {
            position: 'relative',
            width: 100,
            height: 100,
        },
        currentStreakIcon: {
            width: 100,
            position: 'absolute',
        },
        currentStreakCount: {
            fontSize: '32px',
            color: '#FFF',
            fontWeight: 'bold',
            position: 'absolute',
            width: '100%',
            textAlign: 'center',
            top: 46,
        },
        description: {
            flex: 1,
            marginLeft: theme.spacing(2),
        },
        bottomRow: {
            marginTop: theme.spacing(2),
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
        },
        historyHeading: {
            width: '100%',
            textAlign: 'center',
            fontSize: '1rem',
        },
        historyItem: {
            position: 'relative',
            padding: theme.spacing(0.5),
            width: 34 + theme.spacing(1),
            height: 34 + theme.spacing(1),
        },
        historyItemIcon: {
            width: 34,
            position: 'absolute',
            top: theme.spacing(1),
            left: theme.spacing(1),
        },
        historyItemLabel: {
            fontSize: '14px',
            color: '#FFF',
            fontWeight: 'bold',
            position: 'absolute',
            width: '100%',
            textAlign: 'center',
            top: 20,
        },
    });
});
var StreakCounterPopover = function (_a) {
    var children = _a.children, recentStreak = _a.recentStreak, currentStreak = _a.currentStreak, other = __rest(_a, ["children", "recentStreak", "currentStreak"]);
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Popover, __assign({ classes: { root: classes.root, paper: classes.paper }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        } }, other),
        react_1.default.createElement("div", { className: classes.topRow },
            react_1.default.createElement("div", { className: classes.currentStreak },
                react_1.default.createElement(StreakCounterCountIcon_1.default, { variant: "red", className: classes.currentStreakIcon }),
                react_1.default.createElement("div", { className: classes.currentStreakCount }, currentStreak)),
            react_1.default.createElement("div", { className: classes.description },
                react_1.default.createElement(core_1.Typography, { gutterBottom: true, variant: "h3" }, "Streak"),
                react_1.default.createElement(core_1.Typography, { color: "textSecondary" }, "Review cards every day to build your streak"))),
        react_1.default.createElement("div", { className: classes.bottomRow },
            react_1.default.createElement(core_1.Typography, { color: "textSecondary", variant: "h6", className: classes.historyHeading }, "Past week"),
            recentStreak.map(function (day, index) { return (react_1.default.createElement("div", { className: classes.historyItem },
                react_1.default.createElement(StreakCounterCountIcon_1.default
                // eslint-disable-next-line no-nested-ternary
                , { 
                    // eslint-disable-next-line no-nested-ternary
                    variant: !day ? 'gray' : day > 1 ? 'blue' : 'red', className: classes.historyItemIcon }),
                react_1.default.createElement("div", { className: classes.historyItemLabel }, getDayLabel(index, recentStreak.length)))); })),
        react_1.default.createElement("div", { className: classes.arrow })));
};
exports.default = StreakCounterPopover;
//# sourceMappingURL=StreakCounterPopover.js.map